export const DATA_INTERVAL_TYPES = {
    1: 5, // minutes
    2: 20,
    3: 60,
    4: 1440, // 1day
};
